import React from 'react';
import PropTypes from 'prop-types';
import {Slide} from 'react-slideshow-image';
import 'react-slideshow-image/dist/styles.css';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';

// components
import Container from './components/Container';
import ImagesContainer from './components/ImagesContainer';
import LoginContainer from './components/LoginContainer';
import LoginButton from './components/LoginButton';
import Error from './components/Error';
import SlideImage from './components/SlideImage';

// config
import { getLogo } from '../../../lib/logoConfig';

// colors
import { white } from '../../../style/colors';

// images
import img1 from '../../../assets/images/Conti-APP_banner-1.jpg';
import img2 from '../../../assets/images/Conti-APP_banner-2.jpg';
import img3 from '../../../assets/images/Conti-APP_banner-3.jpg';
import img4 from '../../../assets/images/Conti-APP_banner-4.jpg';
import img5 from '../../../assets/images/Conti-APP_banner-5.jpg';

const LogoBox = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 20px 0;
`;

const LogoBrand = styled.div`
  font-family: 'Times New Roman', Times, serif;
  font-size: 28px;
  font-weight: 400;
  letter-spacing: 8px;
  color: ${white};
  text-transform: uppercase;
`;

const LogoCountry = styled.div`
  font-family: 'Times New Roman', Times, serif;
  font-size: 14px;
  font-weight: 400;
  letter-spacing: 6px;
  color: ${white};
  margin-top: 4px;
`;

const SignIn = ({error, onSignIn}) => {
  const { t, i18n } = useTranslation();
  const logo = getLogo(i18n.language, true);
  const images = [img1, img2, img3, img4, img5];
  
  return (
    <Container>
      <ImagesContainer className="slide-container">
        <Slide
          autoplay
          arrows={false}
          duration={3000}
          canSwipe={false}
          pauseOnHover={false}
        >
          {images.map((image, index) => (
            <ImagesContainer key={index}>
              <SlideImage src={image} />
            </ImagesContainer>
          ))}
        </Slide>
      </ImagesContainer>
      <LoginContainer>
        <LogoBox>
          <LogoBrand>PORSCHE</LogoBrand>
          {logo.countryName && <LogoCountry>{logo.countryName}</LogoCountry>}
        </LogoBox>
        {error && (
          <Error>
            {t('loginError')}
            <br />
            {t('tryAgain')}
          </Error>
        )}
        <LoginButton onClick={onSignIn}>{t('login')}</LoginButton>
      </LoginContainer>
    </Container>
  );
};

SignIn.propTypes = {
  error: PropTypes.bool,
  onSignIn: PropTypes.func,
};

export default SignIn;
